import React from 'react';
import GridTabItem from './GridTabItem';
import { createGridTabsCss } from '../utils';
import './GridTabs.scss';
export const GridTabs = ({ activeTab = '', tabs = [], disabledTabs = [], onChange = () => { }, className, overrideCss, label, }) => {
    const { gridTabsCss, gridTabsContainerCss, gridTabsLabel } = createGridTabsCss({
        customClassName: className,
        overrideCss,
    });
    return (React.createElement("div", { className: gridTabsCss },
        label ? React.createElement("span", { className: gridTabsLabel }, label) : null,
        React.createElement("div", { className: gridTabsContainerCss }, tabs.map((tab) => (React.createElement(GridTabItem, { key: tab, tab: tab, active: activeTab === tab, disabled: disabledTabs.includes(tab), onChange: onChange, className: className, overrideCss: overrideCss }))))));
};
//# sourceMappingURL=GridTabs.js.map